module.exports = "/images/img-appstore.png?4321de061c15daafee6b992e559f7a5c";